export const popweighte = {
  name: `popweighte`,
  sql: `
    SELECT cartodb_id, the_geom_webmercator, mun, popweighte, haz_eq1, haz_eq2, haz_fld, haz_damg, haz_wf, haz_ls, haz_lev, haz_tsu, haz_slr
    FROM solano_b01_hazards_x_census_point
  `,
  cartoCSS: `
  #layer {
    marker-width: ramp([popweighte], range(2, 25), jenks(5));
    marker-fill: ramp([popweighte], (#80c799, #4da284, #2d7974, #1d4f60), quantiles(4));
    marker-fill-opacity: 1;
    marker-allow-overlap: true;
    marker-line-width: 1;
    marker-line-color: #FFFFFF;
    marker-line-opacity: 1;
    marker-comp-op: src-over;
  }
  `,
}

export const popweighteCategories = {
  name: 'popweighteCategories',
  type: 'Category',
  source: popweighte.sql,
  field: 'mun',
  options: {
    limit: 100,
    operation: 'SUM',
    operationColumn: 'popweighte'
  }
}

export const popweighteSum = {
  name: 'popweighteSum',
  type: 'Formula',
  source: popweighte.sql,
  field: 'popweighte',
  options: {
    operation: 'SUM',
  }
}